module.exports = __webpack_public_path__ + "static/media/47_B.f032fdb3.png";